import { render, staticRenderFns } from "./ReviewsSection.vue?vue&type=template&id=6a63de40"
import script from "./ReviewsSection.vue?vue&type=script&lang=ts"
export * from "./ReviewsSection.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports